'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishAvailabilityMessage = undefined;

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _hasChatMessageFromAgent = require('conversations-schema/thread-history/operators/hasChatMessageFromAgent');

var _getOfficeHoursStartTime = require('conversations-schema/availability/operators/getOfficeHoursStartTime');

var _availabilityConfigGetters = require('conversations-schema/availability/operators/config/availabilityConfigGetters');

var _publishOfficeHoursMessage = require('../../office-hours/actions/publishOfficeHoursMessage');

var _publishTypicalResponseTimeMessage = require('../../typical-response-time/publishTypicalResponseTimeMessage');

var _getWidgetAvailabilityOptions = require('../selectors/getWidgetAvailabilityOptions');

var _getThreadByThreadId = require('../../threads/selectors/getThreadByThreadId');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

var _canSendNewOfficeHoursMessage = require('../../thread-histories/operators/canSendNewOfficeHoursMessage');

var _canSendNewTypicalResponseTimeMessage = require('../../thread-histories/operators/canSendNewTypicalResponseTimeMessage');

function publish(_ref) {
  var channel = _ref.channel,
      thread = _ref.thread,
      state = _ref.state,
      dispatch = _ref.dispatch;

  var availabilityOptions = (0, _getWidgetAvailabilityOptions.getWidgetAvailabilityOptions)(state);
  var officeHoursStartTime = (0, _getOfficeHoursStartTime.getOfficeHoursStartTime)(availabilityOptions);
  var typicalResponseTime = (0, _availabilityConfigGetters.getTypicalResponseTime)(availabilityOptions);
  var shouldPublishOfficeHoursMessage = !!officeHoursStartTime;
  var shouldPublishTypicalResponseTimeMessage = !!typicalResponseTime;
  var threadId = (0, _threadGetters.getThreadId)(thread);

  var threadHistory = (0, _historyDataForThread.historyDataForThread)(state, { thread: thread });

  if (shouldPublishOfficeHoursMessage) {
    if ((0, _canSendNewOfficeHoursMessage.canSendNewOfficeHoursMessage)(threadHistory)) {
      dispatch((0, _publishOfficeHoursMessage.publishOfficeHoursMessage)({ channel: channel, threadId: threadId }));
    }
  } else {
    if (shouldPublishTypicalResponseTimeMessage) {
      if ((0, _canSendNewTypicalResponseTimeMessage.canSendNewTypicalResponseTimeMessage)(threadHistory)) {
        dispatch((0, _publishTypicalResponseTimeMessage.publishTypicalResponseTimeMessage)({
          channel: channel,
          threadId: threadId
        }));
      }
    }
  }
}

var publishAvailabilityMessage = exports.publishAvailabilityMessage = function publishAvailabilityMessage(_ref2) {
  var channel = _ref2.channel,
      threadId = _ref2.threadId;

  return function (dispatch, getState) {
    var thread = (0, _getThreadByThreadId.getThreadByThreadId)(getState(), { threadId: threadId });

    var threadHistory = (0, _historyDataForThread.historyDataForThread)(getState(), { thread: thread });

    if (threadHistory && (0, _hasChatMessageFromAgent.hasChatMessageFromAgent)(threadHistory)) {
      return;
    }

    publish({ channel: channel, thread: thread, state: getState(), dispatch: dispatch });
  };
};